import { call, put, all, select } from 'redux-saga/effects'
import {
  getAppDataSuccess,
  getAppDataError,
  postOrdersMultisimSuccess,
  patchOrdersMultisimOrderIdSuccess,
  postOrdersMultisimError,
  patchOrdersMultisimOrderIdError,
} from './dataActions'
import {
  getUsersApi,
  getEsimApi,
  getProductsApi,
  postOrdersMultisimApi,
  patchOrdersMultisimApi,
  PostOrdersMultisimData,
  PatchOrdersMultisimData,
} from './dataApi'
import {
  postOrdersMultisimProductIdSelector,
  productMobileDataSelector,
  exchangeMultisimSelector,
} from './dataSelectors'
import { watchEidSelector } from '../watch/watchSelectors'
import { AxiosResponse } from 'axios'
import { isUserLoggedInSelector } from '../auth/authSelectors'
import { i18n } from '../../i18n'
import BugSnag from '../../config/bugsnag'
import { logException, logEvent } from '../../utils/googleAnalytics'

export function* getDataRequestSaga() {
  try {
    const isUserLoggedIn = yield select(isUserLoggedInSelector)
    if (isUserLoggedIn) {
      const { data: usersData } = yield call(getUsersApi)
      BugSnag.bugsnagClient.user = {
        id: usersData.id,
        name: `${usersData.firstName} ${usersData.lastName}`,
        email: usersData.email,
      }
      const [{ data: productsData }, { data: esimData }] = yield all([call(getProductsApi), call(getEsimApi)])

      const watchEid = yield select(watchEidSelector)
      const filteredEsimData = esimData && esimData.filter(esim => esim.eId === watchEid)
      if (Array.isArray(filteredEsimData) && filteredEsimData.length > 1) {
        throw new Error('error')
      }
      yield put(getAppDataSuccess({ usersData, productsData, esimData }))
    }
  } catch (err) {
    const errorMessage = i18n.t('common:generalSagaError')
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    if (err.response.status !== 401) {
      yield put(getAppDataError({ error: errorMessage }))
    }
  }
}

export function* postOrdersMultisimSaga() {
  try {
    const eid = yield select(watchEidSelector)
    const { id: parentId } = yield select(productMobileDataSelector)
    const exchangeMultisim = yield select(exchangeMultisimSelector)
    const multisimId = exchangeMultisim && exchangeMultisim.id

    const { data }: AxiosResponse<PostOrdersMultisimData> = yield call(postOrdersMultisimApi, parentId, multisimId)
    yield put(postOrdersMultisimSuccess({ data }))
    logEvent('Post for additional card', `WatchEid: ${eid}, parentMobileAccess: ${parentId}`)
  } catch (err) {
    const errorMessage = i18n.t('common:generalSagaError')
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    yield put(
      postOrdersMultisimError({
        error: errorMessage,
      })
    )
  }
}

export function* patchOrdersMultisimSaga() {
  try {
    const postMultisimOrderId = yield select(postOrdersMultisimProductIdSelector)
    const eid = yield select(watchEidSelector)
    if (eid) {
      const { data }: AxiosResponse<PatchOrdersMultisimData> = yield call(
        patchOrdersMultisimApi,
        eid,
        postMultisimOrderId
      )
      yield put(patchOrdersMultisimOrderIdSuccess({ data }))
      logEvent('Buy additional card', `WatchEid: ${eid}, orderId: ${postMultisimOrderId}`)
    }
  } catch (err) {
    const errorMessage = i18n.t('common:generalSagaError')
    BugSnag.bugsnagClient.notify(err)
    logException(errorMessage)
    yield put(
      patchOrdersMultisimOrderIdError({
        error: errorMessage,
      })
    )
  }
}
